// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Theme = require("../../../reason/common/Theme/Theme.bs.js");
let Responsive = require("./Responsive.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function $$eval(x) {
  if (typeof x === "object") {
    return Responsive.mapResponsive($$eval, x);
  } else if (x === "left") {
    return "left";
  } else if (x === "right") {
    return "right";
  } else if (x === "matchParent") {
    return "match-parent";
  } else if (x === "justify") {
    return "justify";
  } else if (x === "start") {
    return "start";
  } else if (x === "center") {
    return "center";
  } else if (x === "justifyAll") {
    return "justify-all";
  } else {
    return "end";
  }
}

let TextAlign = {
  $$eval: $$eval
};

function $$eval$1(x) {
  if (typeof x === "object") {
    return Responsive.mapResponsive($$eval$1, x);
  } else if (x === "inherit_") {
    return "inherit";
  } else if (x === "capitalize") {
    return "capitalize";
  } else if (x === "lowercase") {
    return "lowercase";
  } else if (x === "uppercase") {
    return "uppercase";
  } else {
    return "none";
  }
}

let TextTransform = {
  $$eval: $$eval$1
};

function $$eval$2(x) {
  if (typeof x === "object") {
    return Responsive.mapResponsive($$eval$2, x);
  } else if (x === "normal") {
    return "normal";
  } else {
    return "italic";
  }
}

let FontStyle = {
  $$eval: $$eval$2
};

function $$eval$3(x) {
  let variant = x.NAME;
  if (variant === "em") {
    return x.VAL.toString() + "em";
  } else if (variant === "px") {
    return x.VAL.toString() + "px";
  } else if (variant === "num") {
    return x.VAL.toString();
  } else if (variant === "rem") {
    return x.VAL.toString() + "rem";
  } else {
    return Responsive.mapResponsive($$eval$3, x);
  }
}

let FontSize = {
  $$eval: $$eval$3
};

function $$eval$4(_x) {
  while (true) {
    let x = _x;
    if (typeof x === "object") {
      let variant = x.NAME;
      if (variant === "num" || variant === "n") {
        return x.VAL.toString();
      } else {
        return Responsive.mapResponsive($$eval$4, x);
      }
    }
    if (x === "light") {
      _x = Theme.FontWeight.light;
      continue;
    }
    if (x === "medium") {
      _x = Theme.FontWeight.medium;
      continue;
    }
    if (x === "regular") {
      _x = Theme.FontWeight.regular;
      continue;
    }
    _x = Theme.FontWeight.bold;
    continue;
  };
}

let FontWeight = {
  $$eval: $$eval$4
};

function $$eval$5(x) {
  let variant = x.NAME;
  if (variant === "float" || variant === "num" || variant === "n") {
    return x.VAL.toString();
  } else if (variant === "em") {
    return x.VAL.toString() + "em";
  } else if (variant === "px") {
    return x.VAL.toString() + "px";
  } else {
    return Responsive.mapResponsive($$eval$5, x);
  }
}

let LineHeight = {
  $$eval: $$eval$5
};

function $$eval$6(x) {
  if (typeof x === "object") {
    return Responsive.mapResponsive($$eval$6, x);
  } else if (x === "preLine") {
    return "pre-line";
  } else if (x === "preWrap") {
    return "pre-wrap";
  } else if (x === "breakSpaces") {
    return "break-spaces";
  } else if (x === "normal") {
    return "normal";
  } else if (x === "nowrap") {
    return "nowrap";
  } else {
    return "pre";
  }
}

let WhiteSpace = {
  $$eval: $$eval$6
};

let baseClasses = "text-zinc-700 mt-0 mb-2 last:mb-0 leading-tight";

function Heading__Jsx3(props) {
  let children = props.children;
  let __className = props.className;
  let __as_ = props.as_;
  let as_ = __as_ !== undefined ? __as_ : "h3";
  let className = __className !== undefined ? __className : "";
  if (as_ === "h2") {
    return JsxRuntime.jsx("h2", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-light text-[22px] sm:text-[22px] md:text-[26px] lg:text-[32px]",
        className
      ])
    });
  } else if (as_ === "h3") {
    return JsxRuntime.jsx("h3", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-light text-[20px] sm:text-[20px] md:text-[24px] lg:text-[26px]",
        className
      ])
    });
  } else if (as_ === "h4") {
    return JsxRuntime.jsx("h4", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-medium text-[17px] sm:text-[17px] md:text-[20px] lg:text-[22px]",
        className
      ])
    });
  } else if (as_ === "h5") {
    return JsxRuntime.jsx("h5", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-medium text-[16px]",
        className
      ])
    });
  } else if (as_ === "h6") {
    return JsxRuntime.jsx("h6", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-medium text-[14px]",
        className
      ])
    });
  } else {
    return JsxRuntime.jsx("h1", {
      children: children,
      className: TailwindMerge.twMerge([
        baseClasses,
        "font-light text-[22px] sm:text-[22px] md:text-[26px] lg:text-[42px]",
        className
      ])
    });
  }
}

let make = Heading__Jsx3;

exports.TextAlign = TextAlign;
exports.TextTransform = TextTransform;
exports.FontStyle = FontStyle;
exports.FontSize = FontSize;
exports.FontWeight = FontWeight;
exports.LineHeight = LineHeight;
exports.WhiteSpace = WhiteSpace;
exports.baseClasses = baseClasses;
exports.make = make;
/* tailwind-merge Not a pure module */
